<template>
  <div class="history-container" v-if="list && list.length">
    <div class="history-header">最近浏览</div>
    <div :class="['history-list', showNavBtns ? '' : 'hide-navs']">
      <!-- <i :class="['iconfont', xSwiper.isBeginning ? 'disabled' : 'enabled']" @click="sliderTo(-1)">&#xe615;</i> -->
      <swiper class="swiper-x-container" :options="swiperOption" ref="xSwiper">
        <swiper-slide class="swiper-x-item" v-for="(item, index) in list" :key="index">
          <ListItem :data="item" scope="history" />
        </swiper-slide>
        <i class="iconfont icon-left-arrow" slot="button-prev">&#xe615;</i>
        <i class="iconfont icon-right-arrow" slot="button-next">&#xe628;</i>
      </swiper>
      <!-- <i :class="['iconfont', xSwiper.isEnd ? 'disabled' : 'enabled']" @click="sliderTo(+1)">&#xe628;</i> -->
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import ListItem from "@/components/ListItem.vue";
import types from '@/store/types';
import api from '@/utils/api';

export default {
  name: "Recommend",
  components: { swiper, swiperSlide, ListItem },
  props: {
    uid: {
      type: Number,
      // required: true
    }
  },
  data() {
    return {
      xSwiper: {},
      swiperOption: {
        slidesPerView: 4,
        breakpoints: {
          960: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 10
          }
        },
        navigation: {
          nextEl: '.icon-right-arrow',
          prevEl: '.icon-left-arrow'
        }
      },
      list: []
    };
  },
  created() {
    this.loadSource();
  },
  methods: {
    loadSource() {
      api[types.VIEWED]({ id: this.uid }).then(res => {
        if (res?.code == 1) {
          this.list = res?.data;
          this.$nextTick(() => {
            this.xSwiper = this.$refs?.xSwiper?.swiper;
          });
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    sliderTo(offset) {
      if (offset == -1) {
        this.xSwiper?.slidePrev();
      } else {
        this.xSwiper?.slideNext();
      }
    }
  },
  computed: {
    showNavBtns() {
      let size = this.list.length;
      let winW = window.innerWidth;
      let opts = this.swiperOption.breakpoints;
      if (
        (winW > 960 && size > opts['1024'].slidesPerView) ||
        (winW <= 960 && size > opts['960'].slidesPerView)
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.history-container {
  max-width: 1200px;
  margin: 0 auto;

  .history-header {
    // font-weight: 700;
    // font-size: calc(1.5rem * 1.6);
    font-size: 20px;
    line-height: 3.4375rem;
    font-style: normal;
    color: #000;
    text-align: center;
    padding: 24px 0;
  }

  .history-list {
    display: flex;
    justify-content: center;
    align-items: center;

    &.hide-navs {
      .iconfont {
        display: none;
      }
    }

    .iconfont {
      font-size: 38px;
      cursor: pointer;

      &.disabled {
        color: #EFEFEF;
        cursor: not-allowed;
      }
    }

    .swiper-x-container {
      width: 100%;
      min-height: 200px;

      // & ::v-deep .swiper-wrapper { }
      .swiper-x-item {
        height: auto; //item高度不一样border会很奇怪 需要统一
        border-left: 1px solid #b4b5b4;

        &:first-child {
          border-left: none;
        }
      }

      .icon-left-arrow,
      .icon-right-arrow {
        font-size: 28px;
        position: absolute;
        top: 50%;
        z-index: 1;
        transform: translate(0, -50%);

        &.swiper-button-disabled {
          color: #efefef;
        }
      }

      .icon-left-arrow {
        left: 0;
      }

      .icon-right-arrow {
        right: 0;
      }
    }
  }
}
</style>
